<template lang="pug">
v-list.factsheet.py-4(subheader)
	.px-4.mb-5(v-if="!hideMap")
		nuxt-link(v-if="skimap" :to="localePath({name: 'areas-area-skimaps', params: { area: slug }})" :title="$t('infosheet.skimap-link.title_{area}', {area: name})")
			v-img(:aspect-ratio="16/9" :src="`${skimap.url}?width=640`" :alt="skimap.alt")
		nuxt-link(:to="localePath({name: 'areas-area-plan', params: { area: slug }})" :title="$t('infosheet.plan-map-link.title_{area}', {area: name})")
			v-sheet.pa-1.caption(color="accent" dark tile)
				ws-icon.mr-1(small) search
				| {{$t('infosheet.check-plan-map.label')}}

	template(v-if="minElevation && maxElevation")
		.black--text.px-4.d-flex.justify-space-between.mb-3(v-if="minElevation > 0")
			.caption.font-weight-bold {{$t('infosheet.min-elevation')}}
			.caption.text-right {{minElevation}}m
		.black--text.px-4.d-flex.justify-space-between.mb-4(v-if="maxElevation > 0")
			.caption.font-weight-bold {{$t('infosheet.max-elevation')}}
			.caption.text-right {{maxElevation}}m
		v-divider.mx-4.mb-4

	.black--text.px-4.d-flex.justify-space-between.mb-3(v-if="slopeinfo.total > 0")
		.caption.font-weight-bold {{$t('infosheet.slopes.total')}}
		.caption.text-right {{slopeinfo.total}}km
	.black--text.px-4.d-flex.justify-space-between.mb-3(v-if="slopeinfo.green > 0")
		.caption.font-weight-bold(style="width:90px") {{$t('infosheet.slopes.green')}}
		span.factsheet--bar.grow
			i.piste-green(:style="`width:${slopeinfo.green_percentage}%;`")
		.caption.text-right(style="width:50px") {{slopeinfo.green}}km
	.black--text.px-4.d-flex.justify-space-between.mb-3(v-if="slopeinfo.blue > 0")
		.caption.font-weight-bold(style="width:90px") {{$t('infosheet.slopes.blue')}}
		span.factsheet--bar.grow
			i.piste-blue(:style="`width:${slopeinfo.blue_percentage}%;`")
		.caption.text-right(style="width:50px") {{slopeinfo.blue}}km
	.black--text.px-4.d-flex.justify-space-between.mb-3(v-if="slopeinfo.red > 0")
		.caption.font-weight-bold(style="width:90px") {{$t('infosheet.slopes.red')}}
		span.factsheet--bar.grow
			i.piste-red(:style="`width:${slopeinfo.red_percentage}%;`")
		.caption.text-right(style="width:50px") {{slopeinfo.red}}km
	.black--text.px-4.d-flex.justify-space-between.mb-4(v-if="slopeinfo.black > 0")
		.caption.font-weight-bold(style="width:90px") {{$t('infosheet.slopes.black')}}
		span.factsheet--bar.grow
			i.piste-black(:style="`width:${slopeinfo.black_percentage}%;`")
		.caption.text-right(style="width:50px") {{slopeinfo.black}}km

	v-divider.mx-4.mt-6.mb-3
	v-row(no-gutters)
		v-col(cols="12" lg="6" v-if="slopeinfo.gondola > 0")
			fact-field(:label="$t('infosheet.lifts.gondola')" icon="gondola") {{slopeinfo.gondola}}
		v-col(cols="12" lg="6" v-if="slopeinfo.chairlift > 0")
			fact-field(:label="$t('infosheet.lifts.chairlift')" icon="chair-lift") {{slopeinfo.chairlift}}
		v-col(cols="12" lg="6" v-if="slopeinfo.tbar > 0" )
			fact-field(:label="$t('infosheet.lifts.tbar')" icon="t-bar") {{slopeinfo.tbar}}
		v-col(cols="12" lg="6" v-if="slopeinfo.magiccarpet > 0")
			fact-field(:label="$t('infosheet.lifts.magiccarpet')" icon="conveyor") {{slopeinfo.magiccarpet}}

	v-divider.mx-4.my-3(v-if="clusters.length || snowheights && snowheights.nodes[0]")
	v-list-item(v-if="snowheights && snowheights.nodes[0]")
		v-list-item-avatar.mr-2
			ws-icon calendar
		v-list-item-content.py-2(v-if="snowheights.nodes[0].isResortOpen")
			v-list-item-title.caption.success--text.font-weight-bold {{$t('infosheet.currently.open')}}
			v-list-item-subtitle.caption.black--text( style="white-space:normal;") {{$t('infosheet.open.till')}} {{trueSeasonEnd ? $dayjs(trueSeasonEnd).format('D MMMM') : $t('season.date.unknown')}}
		v-list-item-content.py-2(v-else)
			v-list-item-title.caption.error--text.font-weight-bold {{$t('infosheet.currently.closed')}}
			v-list-item-subtitle.caption.black--text( style="white-space:normal;") {{$t('infosheet.open.from')}} {{trueSeasonStart ? $dayjs(trueSeasonStart).format('D MMMM') : $t('season.date.unknown')}} - {{trueSeasonEnd ? $dayjs(trueSeasonEnd).format('D MMMM') : $t('season.date.unknown')}}

	v-list-item(v-if="clusters.length")
		v-list-item-avatar.mr-2.align-self-start(height="28")
			ws-icon information-circle
		v-list-item-content.py-2
			.caption.black--text
				span {{$t('infosheet.part.of_{area}', {area: name})}}
				|
				|
				glue-list
					span(v-for="cluster in clusters" :key="cluster.slug")
						nuxt-link.font-weight-bold(:to="localePath({name: 'clusters-cluster', params:{cluster:cluster.slug}})" :title="cluster.name") {{cluster.name}}
						|
						|
						span ({{cluster.totalkms}}km)
				.caption.black--text(v-if="!slopeinfo.hasConnectedSlopes") {{$t('infosheet.slopes-not-connected')}}

	template(v-if="['nl-NL', 'nl-BE'].includes($i18n.locale)")
		v-divider.mt-3(v-if="accommodations || skischools || rentals")
		v-list-item.mb-n4(v-if="accommodations")
			v-list-item-avatar.mr-2
				ws-icon bed
			v-list-item-content
				v-list-item-title.caption
					nuxt-link(:to="localePath({name: 'areas-area-accommodationtype', params: { area: slug, accommodationtype: $localeSlug('accommodations', $i18n.locale) }})") {{$t('infosheet.facilities.accommodations_{count}', {count: accommodations})}}
		v-list-item.mb-n4(v-if="skischools")
			v-list-item-avatar.mr-2
				ws-icon ski
			v-list-item-content(style="flex-shrink: 1")
				v-list-item-title.caption
					nuxt-link(:to="localePath({name: 'areas-area-lesson', params: { area: slug }})") {{skischools}} {{$t('infosheet.facilities.skischools')}}
			v-list-item-content(style="flex-grow: 2")
				nuxt-link(:to="localePath({name: 'areas-area-lesson', params: { area: slug }})")
					v-img(src="https://cdn.wintersport.nl/media/partners/2020/10/05/Partner_logo_checkyeti_(320x106px).jpg" width="70" height="24" contain)
		v-list-item.mb-n4(v-if="rentals")
			v-list-item-avatar.mr-2
				v-icon store
			v-list-item-content
				v-list-item-title.caption
					nuxt-link(:to="localePath({name: 'areas-area-rental', params: { area: slug }})") {{rentals}} {{$t('infosheet.facilities.rentals')}}

</template>

<style lang="sass">
.factsheet
	.caption
		font-size: 13px !important

	.factsheet--bar
		display: block
		text-align: left
		display: block
		position: relative
		line-height: 1
		padding: 0.4rem
		min-width: 100px
		background-color: #F9F9F9

		i
			color: #fff
			overflow: hidden
			position: absolute
			font-style: normal
			display: inline-block
			white-space: nowrap
			vertical-align: baseline
			max-width: 100%
			left: 0
			top: 0
			bottom: 0
			height: 100% !important
			text-align: right
			box-sizing: border-box
			padding: 0.4rem 0
			text-indent: 0.4rem

		@each $name, $color in $piste-colors
			.piste-#{$name}
				background-color: $color !important
</style>

<script>
import {
	VListItem,
	VListItemTitle,
	VListItemAvatar,
	VListItemSubtitle,
	VListItemContent
} from 'vuetify/lib';

const FactField = {
	functional: true,

	render(createElement, context) {
		let label = null;
		let icon = null;
		if (context.props.label) {
			label = createElement(
				VListItemSubtitle,
				{ class: 'caption font-weight-bold black--text' },
				[context.props.label]
			);
		}

		if (context.props.icon) {
			icon = createElement(VListItemAvatar, { class: 'mr-2' }, [
				createElement('ws-icon', {}, [context.props.icon])
			]);
		}

		const title = createElement(
			VListItemTitle,
			{ class: 'caption' },
			context.children
		);
		const content = createElement(VListItemContent, { class: 'py-2' }, [
			label,
			title
		]);

		return createElement(VListItem, { props: {} }, [icon, content]);
	}
};
export default {
	components: {
		FactField
	},
	props: {
		name: {
			type: String,
			default: null
		},
		slug: {
			type: String,
			default: null
		},
		maxElevation: {
			type: Number,
			default: 0
		},
		hideMap: {
			type: Boolean,
			default: false
		},
		minElevation: {
			type: Number,
			default: 0
		},
		slopeinfo: {
			type: Object,
			default: () => ({})
		},
		clusters: {
			type: Array,
			default: () => []
		},
		snowheights: {
			type: Object,
			default: () => {}
		},
		skimap: {
			type: Object,
			default: () => ({})
		},
		accommodations: {
			type: Number,
			default: 0
		},
		skischools: {
			type: Number,
			default: 0
		},
		rentals: {
			type: Number,
			default: 0
		}
	},
	computed: {
		trueSeasonStart() {
			const seasonStarts = [...this.snowheights.nodes].filter(
				snowheight => !!snowheight.seasonStartsAt
			);

			if (!seasonStarts.length) return false;

			const sortedBySeasonStart = seasonStarts.sort((a, b) => {
				return (
					new Date(a.seasonStartsAt).getTime() -
					new Date(b.seasonStartsAt).getTime()
				);
			});

			return sortedBySeasonStart[0].seasonStartsAt;
		},
		trueSeasonEnd() {
			const seasonEnds = [...this.snowheights.nodes].filter(
				snowheight => !!snowheight.seasonEndsAt
			);

			if (!seasonEnds.length) return false;

			const sortedBySeasonEnd = seasonEnds.sort((a, b) => {
				return (
					new Date(a.seasonEndsAt).getTime() -
					new Date(b.seasonEndsAt).getTime()
				);
			});

			return sortedBySeasonEnd[sortedBySeasonEnd.length - 1].seasonEndsAt;
		}
	}
};
</script>
